import { useEffect } from 'react';

/**
 * Structured Data Component
 * Injects JSON-LD structured data for SEO (Event, Prize, Person schemas)
 */
const StructuredData = ({ type, data }) => {
  useEffect(() => {
    // Create or update the structured data script tag
    const scriptId = `structured-data-${type}`;
    let script = document.getElementById(scriptId);
    
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    
    script.textContent = JSON.stringify(data);
    
    console.log(`StructuredData: ${type} schema injected`);
    
    // Cleanup on unmount
    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [type, data]);

  return null;
};

// Helper function to generate Event schema
export const getEventSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Event",
  "name": "World Underwater Macro Awards 2026",
  "description": "The first international competition dedicated to underwater macro photography. Over US$41,000 in prizes across 8 categories. The 2026 winners are now published.",
  "startDate": "2026-01-19",
  "endDate": "2026-05-07",
  "eventStatus": "https://schema.org/EventScheduled",
  "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",
  "location": {
    "@type": "VirtualLocation",
    "url": "https://wuma.photo"
  },
  "organizer": {
    "@type": "Organization",
    "name": "World Underwater Macro Awards",
    "url": "https://wuma.photo",
    "logo": "https://wuma.photo/wuma-logo.png"
  },
  "offers": {
    "@type": "Offer",
    "name": "Competition Entry",
    "price": "0",
    "priceCurrency": "USD",
    "availability": "https://schema.org/SoldOut",
    "url": "https://wuma.photo/competition/2026",
    "validFrom": "2026-01-19"
  },
  "image": "https://wuma.photo/images/og-image.jpg",
  "url": "https://wuma.photo/competition/2026"
});

// Helper function to generate Prizes schema (as CreativeWork with Award)
export const getPrizesSchema = () => ({
  "@context": "https://schema.org",
  "@type": "CompetitionEvent",
  "name": "Underwater Macro Awards 2026",
  "award": [
    {
      "@type": "MonetaryGrant",
      "name": "Grand Prize - Macro Category",
      "description": "Overall winner receives premium underwater photography equipment",
      "funder": {
        "@type": "Organization",
        "name": "Marelux"
      }
    },
    {
      "@type": "MonetaryGrant",
      "name": "Category Winners",
      "description": "8 category winners receive prizes from sponsors including Planet Dive Anilao, Ondina Liveaboard, and Marelux",
      "amount": {
        "@type": "MonetaryAmount",
        "currency": "USD",
        "value": "41000"
      }
    }
  ]
});

// Helper function to generate Organization with judges (Person schema)
export const getJudgesSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "World Underwater Macro Awards",
  "url": "https://wuma.photo",
  "member": [
    {
      "@type": "Person",
      "name": "Judging Panel 2026",
      "description": "Prestigious panel of renowned marine photographers and marine biology experts",
      "memberOf": {
        "@type": "Organization",
        "name": "World Underwater Macro Awards"
      }
    }
  ]
});

export default StructuredData;
